import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../../envisia/auth/axios-http-client';
import {FetchPositionFreezeForm} from './fetch-position-freeze-form.models';
import {EnvisiaObject} from '../../../../common/wrapper.models';
import {FetchPosition} from '../../../../envisia/workflow/models/fetch.models';

export function useFetchPositionFreezeMutation(id: number): UseMutationResult<EnvisiaObject<FetchPosition>> {
  return useMutation({
    mutationFn: (form: FetchPositionFreezeForm) =>
      AxiosHttpClient.put<EnvisiaObject<FetchPosition>>(`/workflow/v1/fetch/position/freeze/${id}/`, form),
  });
}
